import { createFileRoute } from '@tanstack/react-router';
import { CashEntriesPage } from '@/features/cash-entries/cash-entries-page';

/** المقبوضات والمدفوعات: the cashier's box receipts and payments (currency.md section 3.1.3). */
export const Route = createFileRoute('/_app/cash')({
  component: CashEntriesPage,
});
